import styled, { css } from 'styled-components'
import { cardisTheme } from '../../theme/cardisTheme'

const printStyles = css`
  @media print {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ChartContainer = styled.div`
  background: ${cardisTheme.colors.white};
  width: 100%;

  @media print {
    background: ${cardisTheme.colors.white} !important;
    ${printStyles}
  }
`
